module.exports = __webpack_public_path__ + "static/media/0025_IMG_LE_PLAFOND_RAL_9010.22bd3156.webp";